import * as types from './actionTypes'

const initialState = {
  message: '',
  isShow: false,
  timeOut: -1,
}

export default function toast(state = initialState, action = {}) {
  switch (action.type) {
    case types.UPDATE_TOAST:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
